import { updatePremiumPreviewData } from '../actions/premiumPreviewActions';
import { orchestrator } from 'satcheljs';
import { getPremiumPreviewStatus } from '../utils/getPremiumPreviewStatus';
import { onUpdatePremiumSuggestionsData } from '../mutators/freeTrialActions';
import { lazyStartPremiumPreviewTimeBased, lazyUpdateSettingDirectly } from 'owa-proofing-option';
import { PremiumPreviewType, PremiumPreviewStatus } from '../store/schema/PremiumPreviewData';

/**
 * This orchestrator should get call in two scenarios:
 * 1) When user click 'try now' button
 * 2) On initialize the Proofing editor
 */
orchestrator(updatePremiumPreviewData, async actionMessage => {
    let premiumPreviewStatus: PremiumPreviewStatus;
    if (actionMessage.shouldUpdateOptionSettings) {
        if (actionMessage.premiumPreviewType === PremiumPreviewType.TimeBased) {
            await lazyStartPremiumPreviewTimeBased.importAndExecute(actionMessage.numerOfDaysLeft);
        }
        if (actionMessage.premiumPreviewType === PremiumPreviewType.CountBased) {
            await lazyUpdateSettingDirectly.importAndExecute(
                'premiumSuggestionsCount',
                actionMessage.premiumSuggestionsCount
            );
        }
        premiumPreviewStatus = PremiumPreviewStatus.Activated;
    } else {
        premiumPreviewStatus = getPremiumPreviewStatus(
            actionMessage.premiumPreviewType,
            actionMessage.premiumSuggestionsCount,
            actionMessage.numerOfDaysLeft
        );
    }

    onUpdatePremiumSuggestionsData(
        actionMessage.viewState,
        actionMessage.numerOfDaysLeft,
        premiumPreviewStatus,
        actionMessage.premiumPreviewType,
        actionMessage.premiumSuggestionsCount
    );
});
